import React from 'react';
import { Navigate } from 'react-router-dom';
import { Result, Button } from 'antd';
import { useAuth } from '../../../contexts/AuthContext';
import { UserRole } from '../../types/admin.types';
import { AdminLayout } from '../layout/AdminLayout';

interface AdminRouteProps {
    children: React.ReactNode;
    requiredRoles?: UserRole[];
    requireAnyRole?: boolean; // true = нужна любая из ролей, false = нужны все роли
}

export const AdminRoute: React.FC<AdminRouteProps> = ({
    children,
    requiredRoles = [UserRole.MODERATOR, UserRole.SIGNATORY, UserRole.SUPER_ADMIN],
    requireAnyRole = true
}) => {
    const { user, isLoading } = useAuth();

    // Показываем загрузку
    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    // Если пользователь не авторизован
    if (!user) {
        return <Navigate to="/admin" replace />;
    }

    // Проверяем роли
    const userRole = user.role as UserRole;
    console.log('AdminRoute: user =', user);
    console.log('AdminRoute: userRole =', userRole);
    console.log('AdminRoute: requiredRoles =', requiredRoles);
    console.log('AdminRoute: requireAnyRole =', requireAnyRole);

    const hasRequiredRole = requireAnyRole
        ? requiredRoles.includes(userRole)
        : requiredRoles.every(role => userRole === role);

    console.log('AdminRoute: hasRequiredRole =', hasRequiredRole);

    // Если нет нужной роли
    if (!hasRequiredRole) {
        return (
            <AdminLayout>
                <Result
                    status="403"
                    title="403"
                    subTitle="У вас нет прав доступа к этой странице"
                    extra={
                        <div className="space-y-2">
                            <div>
                                <Button type="primary" onClick={() => window.history.back()}>
                                    Вернуться назад
                                </Button>
                            </div>
                            <div className="text-sm text-gray-500">
                                Ваша роль: <strong>{getRoleLabel(userRole)}</strong>
                            </div>
                            <div className="text-sm text-gray-500">
                                Требуемые роли: {requiredRoles.map(getRoleLabel).join(', ')}
                            </div>
                        </div>
                    }
                />
            </AdminLayout>
        );
    }

    // Если все проверки пройдены, показываем контент в лейауте
    return (
        <AdminLayout>
            {children}
        </AdminLayout>
    );
};

const getRoleLabel = (role: UserRole) => {
    switch (role) {
        case UserRole.SUPER_ADMIN: return 'Супер-админ';
        case UserRole.MODERATOR: return 'Модератор';
        case UserRole.SIGNATORY: return 'Подписант';
        case UserRole.CLIENT: return 'Клиент';
        default: return role;
    }
};
